// This file is auto-generated by scripts/generate-models.ts
// Do not edit manually - run 'npm run generate-models' to update

import values from "./data/groq.json" with { type: "json" };
import { flattenModelCatalog, type ModelCatalog } from "../model-catalog.ts";

export const GROQ_MODELS: ModelCatalog<typeof values, "groq"> =
	flattenModelCatalog("groq", values);
